var ModifyDataValidate = $.extend({/* ModifyDataValidate */}, BaseComponent, {

	componentSelector: '#modified-data',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				username: {
					required: true,
					minlength: 2
				},
				first_surname: {
				  	required: true,
				  	minlength: 2
				},
				second_surname: {
					required: true,
				  	minlength: 2
				},
				birthdate: {
					required: true
				},
               	email: {
               		required: true,
                    email: true
                },
				address: {
				  	required: true
				},                
				po: {
					required: true,
					digits: true
				},
				location: {
					required: true
				},				
				province: {
					required: true
				},
				language: {
                    required: true
                }
			},
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
                if (element.attr('id') == 'birthdate') {
                    error.insertAfter((element).parents('.input-with-icon-calendar'));
                }
                else if (element.attr('id') == 'language') {
                    error.insertAfter((element).parents('.custom-select-control'));
                }
                else {
                    error.insertAfter(element);
                }
            }
		});

		$(element).find('#modify-data-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));

	}

})